export class CoatingTypes {
  AR = 'AR';
  SCRATCH = 'SCRATCH';
  GLASS = 'GLASS';
  MIRROR = 'MIRROR';
  UV = 'UV';
  PRISM = 'PRISM';
  NPADS = 'NPADS';
  SLAB = 'SLAB';
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/shared/data/coatingTypes.ts